export const LandingPage6Template = {
    slots: ['SlbMarketingContainerSlot'],
};